<ion-header>
  <app-header></app-header>
</ion-header>
<ion-content [fullscreen]="true">
  <h1>{{ "__TEST_TALKJS_CHAT__" | translate }}</h1>

  <div id="talkjs-container" style="height: 600px">{{ "__TEST_LOADING_CHATS__" | translate }}</div>

</ion-content>
